import React, { useState, CSSProperties } from 'react';
import styled, { css } from 'styled-components';


const Track = styled.div`
  height: 100%;
  background-color: #252b33;
  border-radius: 100px;
  box-shadow: 0 1px 4px 0 rgba(70, 70, 70, 0.06);
  padding: 2px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: background-color 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
`;

const Circle = styled.div`
  width: calc(50% - 2px);
  height: 100%;
  border-radius: 100%;
  background-color: #ffffff;
  transition: transform 0.3s;
`;

interface ContainerProps {
  active: boolean;
}

const Container = styled.div<ContainerProps>`
  display: inline-block;
  width: 36px;
  height: 18px;
  font-size: 18px;
  cursor: pointer;

  ${({ active }) => active && css`
    & ${Track} {
      background-color: #009fe4;
      transition: background-color 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
    }

    & ${Circle} {
      transform: translateX(120%);
    }
  `}
`;

interface Props {
  id?: string;
  className?: string;
  active: boolean;
  passiveColor?: string;
  activeColor?: string;
  containerStyle?: CSSProperties;
  onClickHandler: () => void;
}

export default function SwitchControl(props: Props) {
  const {
    id,
    className,
    active,
    passiveColor,
    activeColor,
    containerStyle,
    onClickHandler
  } = props;

  const trackColor = active ? activeColor : passiveColor;

  return (
    <Container
      id={id}
      className={className}
      active={active}
      style={containerStyle}
      onClick={onClickHandler}
    >
      <Track style={{ backgroundColor: trackColor }}>
        <Circle />
      </Track>

    </Container>
  );
}
